/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type {
  GetGlobalLeaderboardOptions,
  GetGlobalLeaderboardResponses,
} from '../types/GetGlobalLeaderboard'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @summary Get global leaderboard
 * {@link /v1/trading/global_leaderboard}
 */
export function getGlobalLeaderboard<ThrowOnError extends boolean = true>(
  options: Options<GetGlobalLeaderboardOptions, ThrowOnError>,
): Unwrappable<RequestResult<GetGlobalLeaderboardResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'GET',
      url: '/v1/trading/global_leaderboard',
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<GetGlobalLeaderboardResponses, ThrowOnError>>,
  )
}
